import "./RightImages.css";
import { useSelector } from "react-redux";

function RightImages() {
  const activeVessel = useSelector((state) => state.flowviewer.activeVessel);
  const files = useSelector((state) => state.flowviewer.files);

  const ImageBlock = ({ imageNumber, isBig = false }) => {
    const imageKey = `image_${activeVessel}_${imageNumber}`;
    const blockClass = isBig ? "right-images-block-big" : "right-images-block";

    return (
      <div className={blockClass}>
        {files[imageKey] ? (
          <img src={files[imageKey]} alt={`Image ${activeVessel} ${imageNumber}`} />
        ) : (
          <div className="right-images-background"></div>
        )}
      </div>
    );
  };

  return (
    <div className="right-images">
      <div className="d-flex justify-content-between position-relative">
        {[1, 2, 3].map((num) => (
          <ImageBlock key={num} imageNumber={num} />
        ))}
      </div>
      <ImageBlock imageNumber={4} isBig={true} />
    </div>
  );
}

export default RightImages;
